Ext.define('SA.lq.ModelState', {
    constructor({data, selectableAttributes, selectableLocations, selectableGeoUnits}) {
        this.data = data;
        this.selectableAttributes = selectableAttributes;
        this.selectableLocations = selectableLocations;
        this.selectableGeoUnits = selectableGeoUnits;
    },

    getConditionList() {
        return this.data.getConditionList();
    },

    getData() {
        return this.data;
    },

    getSelectableAttributes() {
        return this.selectableAttributes;
    },

    getSelectableGeoUnits() {
        return this.selectableGeoUnits;
    },

    getSelectableLocations() {
        return this.selectableLocations;
    },

    getSelectedGeoUnit() {
        return this.data.getGeoUnit();
    },

    getSelectedGeoUnitId() {
        return this.data.getGeoUnitId();
    },

    getSelectedLocationModel() {
        return this.data.getLocationModel();
    },

    getSelectedLocationStringId() {
        return this.data.getLocationStringId();
    },

    getSortModel() {
        return this.data.getSortModel();
    },

    getViewName() {
        return this.data.getViewName();
    },

    hasMaxConditions() {
        return this.data.hasMaxConditions();
    },

    isSavable() {
        return this.data.isSavable();
    },

    isViewable() {
        return this.isSavable();
    }
});